// src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL;

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/login`,
        { username, password },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      
      if (response.status === 200) {
        const { username, email } = response.data;
  
        // Salva os dados do usuário no localStorage
        localStorage.setItem('username', username);
        localStorage.setItem('email', email);
  
        // Lógica de "Lembrar de mim"
        if (rememberMe) {
          localStorage.setItem('rememberMe', 'true');
        } else {
          localStorage.removeItem('rememberMe');
        }
  
        setMessage('');
        navigate('/dashboard'); // Redireciona para o dashboard
      } else {
        setMessage('Credenciais inválidas. Tente novamente.');
      }
    } catch (error) {
      setMessage('Erro ao conectar ao servidor ou credenciais inválidas.');
    }
  };

  useEffect(() => {
    const savedUsername = localStorage.getItem('username');
    const rememberMeChecked = localStorage.getItem('rememberMe') === 'true';
    if (savedUsername && rememberMeChecked) {
      setUsername(savedUsername);
      setRememberMe(true);
    }
  }, []);

  return (
    <div className="login-container">
      <div className="login-form-container">
        <h1>CSC Tracking</h1>
        <h3>Faça seu login</h3>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label>Usuário</label>
            <input
              type="text"
              placeholder="seu usuário"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="login-field password-field">
            <label>Senha</label>
            <div className="password-container">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
          </div>
          <div className="login-options">
            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
              />
              Lembrar de mim
            </label>
            <a href="Dashboard">Esqueceu a senha?</a>
          </div>
          <button type="submit" className="login-button">Entrar</button>
          {message && <p className="login-message">{message}</p>}
          <p className="signup-link">
            Não tem conta ainda? <Link to="/register">Cadastrar</Link>
          </p>
        </form>
      </div>
      <div className="login-image-container">
        <img src="https://i.ibb.co/mvrkv7R/Background.png" alt="Ilustração de Login" />
      </div>
    </div>
  );
}

export default Login;
